import React from 'react';
import { motion } from 'framer-motion';
import { MomAndChild } from './illustrations/MomAndChild';
import { CheckCircle2 } from 'lucide-react';
const benefits = ['Mejora la escritura.', 'Desarrolla la motricidad fina.', 'Favorece la concentración.', 'Reduce el aburrimiento.', 'Incrementa la confianza del niño.', 'Fácil de aplicar en casa o en el aula.'];
export function SolutionSection() {
  return <section className="py-20 bg-pastel-mintLight/30 overflow-hidden" data-id="element-232">
      <div className="container mx-auto px-6 max-w-6xl" data-id="element-233">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-234">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="order-2 lg:order-1" data-id="element-235">
            <MomAndChild data-id="element-236" />
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="order-1 lg:order-2 flex flex-col gap-6" data-id="element-237">
            <h2 className="text-3xl md:text-4xl font-bold text-slate-800 leading-tight" data-id="element-238">
              La forma{' '}
              <span className="text-pastel-mint drop-shadow-sm" data-id="element-239">divertida</span>{' '}
              de aprender a escribir
            </h2>

            <p className="text-lg text-slate-600 leading-relaxed" data-id="element-240">
              <strong className="text-slate-800" data-id="element-241">Método Escribo Jugando</strong>{' '}
              transforma el aprendizaje en una experiencia entretenida mediante
              juegos, desafíos, actividades prácticas y ejercicios progresivos.
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-4" data-id="element-242">
              {benefits.map((benefit, index) => <motion.div key={index} initial={{
              opacity: 0,
              y: 10
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: index * 0.1
            }} className="flex items-center gap-3 bg-white p-4 rounded-xl shadow-sm border border-slate-100" data-id="element-243">
                  <CheckCircle2 className="w-6 h-6 text-pastel-mint shrink-0" data-id="element-244" />
                  <span className="font-semibold text-slate-700" data-id="element-245">
                    {benefit}
                  </span>
                </motion.div>)}
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}